import { Component, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ACCOUNT_FILTER_DEFAULT_REALM, poe1 } from '../../game';
import { RealmSelectorDialogComponent } from '../realm-selector-dialog/realm-selector-dialog.component';
import { BaseComponent } from '../common/base.component';
import { FilterTitleComponent } from '../common/filter-title/filter-title.component';
import { CosmeticsService } from '../services/cosmetics.service';
import { EcoUpdateBehavior } from '../models/economy-models';
import { SelectComponent, SelectOptionComponent } from '../common/select/select.component';
import { LOCAL_STORAGE_KEY_FILTER_DEFAULT_REALM } from '../const';
import { LabelPreviewBackgroundPickerComponent } from '../common/label-preview-background-picker/label-preview-background-picker.component';
import { LabelPreviewBackgroundId } from '../common/label-preview-backgrounds';
import { FileSaveService } from '../services/file-save.service';
import { TooltipWrapperComponent } from '../common/tooltip-wrapper/tooltip-wrapper.component';

import { FilterSnapshotLearnMoreDialogComponent } from '../filter-snapshot-learn-more-dialog/filter-snapshot-learn-more-dialog.component';
import { FilterSnapshotService } from '../services/filter-snapshot.service';

@Component({
  selector: 'app-settings-tab',
  imports: [RealmSelectorDialogComponent, FilterTitleComponent, FormsModule, SelectComponent, SelectOptionComponent, LabelPreviewBackgroundPickerComponent, TooltipWrapperComponent, FilterSnapshotLearnMoreDialogComponent],
  templateUrl: './settings-tab.component.html',
  styleUrl: './settings-tab.component.scss'
})
export class SettingsTabComponent extends BaseComponent {
  showRealmPicker = false;
  showChangeBgDialog = false;
  showFilterSnapshotLearnMore = false;
  origBgImage = this.settings.bgImage();
  realm = localStorage.getItem(LOCAL_STORAGE_KEY_FILTER_DEFAULT_REALM) || ACCOUNT_FILTER_DEFAULT_REALM;
  EcoUpdateBehavior = EcoUpdateBehavior;
  supportsFileSystemAccess: boolean;
  gameFolderButtonText!: ReturnType<typeof computed<string>>;
  gameDirectoryName!: ReturnType<typeof computed<string | null>>;
  showGameFolderHelp!: ReturnType<typeof computed<boolean>>;

  images: BackgroundImageOption[] = poe1 ? [
    { name: 'Sovereign', src: 'sovereign', logo: 'default' },
    { name: 'Water', src: 'water', logo: 'default' },
    { name: 'Abyss', src: 'abyss', logo: 'default' },
    { name: 'Mirage', src: 'mirage', logo: 'default' },
    { name: 'Monks', src: 'monks', logo: 'default' },
    { name: 'Tree', src: 'tree', logo: 'default' },
    { name: 'Hands', src: 'hands', logo: 'default' },
    { name: 'Atlas', src: 'atlas', logo: 'default' },
    { name: 'Kingsmarch', src: 'kingsmarch', logo: 'default' },
    { name: 'Mercenary', src: 'mercenary', logo: 'default' },
    { name: 'Petals', src: 'petals', logo: 'default' },
    { name: 'Secrets', src: 'secrets', logo: 'default' },
    { name: 'Trade Website', src: 'default', logo: 'default' },
   ] :
   [
    { name: 'Aldur Rune', src: 'aldur-rune2', logo: 'default' },
    { name: 'Breach 1', src: 'breach1', logo: 'default' },
    { name: 'Breach 2', src: 'breach2', logo: 'default' },
    { name: 'Delirium', src: 'delirium', logo: 'default' },
    { name: 'Ritual', src: 'ritual', logo: 'default' },
    { name: 'Bodach', src: 'bodach', logo: 'default' },
    { name: 'Ancients', src: 'rota', logo: 'default' },
    { name: 'Martial Artist', src: 'martial-artist', logo: 'default' },
    { name: 'Spirit Walker', src: 'spirit-walker', logo: 'default' },

    { name: 'Druid', src: 'druid', logo: 'default' },
    { name: 'Tornado', src: 'tornado', logo: 'default' },
    { name: 'Vault', src: 'vault', logo: 'default' },

    { name: 'Burning', src: 'burning', logo: 'default' },
    { name: 'Karui Night', src: 'karuinight', logo: 'default' },
    { name: 'Karui Village', src: 'karuivillage', logo: 'default' },
    { name: 'Kingsmarch', src: 'kingsmarchevening', logo: 'default' },
    { name: 'Karui Ship', src: 'karuiship', logo: 'default' },
    { name: 'Karui Beach', src: 'karuibeach', logo: 'default' },

    { name: 'Dawn of the Hunt 1', src: 'huntbg1', logo: 'default' },
    { name: 'Dawn of the Hunt 2', src: 'huntbg2', logo: 'default' },
    { name: 'Huntress 1', src: 'huntress1', logo: 'default' },
    { name: 'Huntress 2', src: 'huntress2', logo: 'default' },

    { name: 'Act 1 Environment', src: 'act1env', logo: 'default' },
    { name: 'Act 1 Boss', src: 'act1boss', logo: 'default' },
    { name: 'Act 1 Concept', src: 'act1concept', logo: 'default' },
    { name: 'Act 1 Town', src: 'act1town', logo: 'default' },
    { name: 'Act 2 Concept', src: 'act2concept', logo: 'default' },
    { name: 'Act 2 Environment', src: 'act2env', logo: 'default' },
    { name: 'Act 3 Concept', src: 'act3concept', logo: 'default' },
    { name: 'Act 3 Environment', src: 'act3env', logo: 'default' },
    { name: 'Trade Website', src: 'default', logo: 'default' },
    { name: 'Lumerius 1', src: 'lumerius1', logo: 'default' },
    { name: 'Lumerius 2', src: 'lumerius2', logo: 'default' },

    { name: 'Zen-mode (none)', src: 'zen', logo: 'zen' },
  ];

  constructor(
    private cosmeticsService: CosmeticsService,
    private fileSaveService: FileSaveService,
    private filterSnapshotService: FilterSnapshotService,
  ) {
    super();
    this.supportsFileSystemAccess = this.fileSaveService.supportsFileSystemAccess;
    this.gameDirectoryName = computed(() => this.fileSaveService.gameDirectoryName());
    this.gameFolderButtonText = computed(() =>
      this.fileSaveService.hasGameDirectory() ? 'Change game folder' : 'Select game folder'
    );
    this.showGameFolderHelp = computed(() =>
      this.fileSaveService.supportsFileSystemAccess && !this.fileSaveService.hasGameDirectory()
    );
  }

  resetTutorials() {
    this.settings.resetTutorials();
  }

  resetAllWarningMessages() {
    this.settings.resetAllWarningMessages();
  }

  toggleAddMoreColorPresets() {
    this.settings.toggleAddMoreColorPresets();
    this.cosmeticsService.buildPresetColors();
  }

  setBackground(img: BackgroundImageOption) {
    this.settings.setBgImage(img.src);
    if (img.logo !== 'zen') {
      document.body.style.backgroundImage = img.src ? `url(${this.assetBaseUrl}/img/bg/${img.src}.webp)` : '';
    } else {
      document.body.style.backgroundImage = 'none';
      document.body.style.backgroundColor = '#000';
    }
  }

  closeChangeBgDialog() {
    this.showChangeBgDialog = false;
    this.settings.trackBackgroundChanged(this.origBgImage);
    this.origBgImage = this.settings.bgImage();
  }

  setLabelPreviewBg(id: LabelPreviewBackgroundId) {
    this.settings.setLabelPreviewBg(id);
  }

  selectGameFolder() {
    void this.fileSaveService.selectGameDirectory();
  }

  toggleFilterSnapshotStorage(): void {
    if (this.settings.filterSnapshotStorageEnabled()) {
      void this.filterSnapshotService.declineStorageConsent();
      return;
    }
    this.settings.setFilterSnapshotStorageEnabled(true);
  }

  toggleFilterSnapshotUsername(): void {
    if (!this.settings.filterSnapshotStorageEnabled()) return;
    void this.filterSnapshotService.setUsernameSharingPreference(!this.settings.filterSnapshotUsernameEnabled());
  }

  allowFilterSnapshotStorage(allowUsername: boolean): void {
    this.filterSnapshotService.confirmStorageConsent(allowUsername);
    this.showFilterSnapshotLearnMore = false;
  }

  optOutFilterSnapshotStorage(): void {
    this.filterSnapshotService.declineStorageConsent();
    this.showFilterSnapshotLearnMore = false;
  }
}

type BackgroundImageOption = {
  name: string;
  src: string;
  logo: string;
};
